import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/parent/'

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const parentDetails = createAsyncThunk('details', (_, thunkAPI) =>
  handleRequest(axios.get(`${api}details`), thunkAPI)
)

export const storeParent = createAsyncThunk('parent-create', (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}store`, data), thunkAPI)
)

export const verifyAccount = createAsyncThunk('verify-account', (data: {}, thunkAPI) =>
  handleRequest(axios.post('/api/verify-account', data), thunkAPI)
)

export const PSFinancial = createAsyncThunk('finance', (_, thunkAPI) =>
  handleRequest(axios.get(`${api}financial-status`), thunkAPI)
)

export const PSNews = createAsyncThunk('ps-news', async (_, thunkAPI) => {
  return handleRequest(axios.get(`${api}news`), thunkAPI)
})
export const PSPlanning = createAsyncThunk('ps-planning', async (_, thunkAPI) => {
  return handleRequest(axios.get(`${api}planning`), thunkAPI)
})

export const PSDocument = createAsyncThunk('docs', async (_, thunkAPI) => {
  return handleRequest(axios.get(`${api}docs`), thunkAPI)
})

export const PSLetters = createAsyncThunk('letters', async (_, thunkAPI) => {
  return handleRequest(axios.get(`${api}letters`), thunkAPI)
})

export const PSNotes = createAsyncThunk('notes', async (_, thunkAPI) => {
  return handleRequest(axios.get(`${api}notes`), thunkAPI)
})

export const SPCourses = createAsyncThunk('courses', async (_, thunkAPI) => {
  return handleRequest(axios.get(`${api}courses`), thunkAPI)
})

export const SPAttendance = createAsyncThunk('attendance', async (id: string, thunkAPI) => {
  return handleRequest(axios.get(`${api}attendance/${id}`), thunkAPI)
})

export const SPLessons = createAsyncThunk('lessons', (id: string, thunkAPI) =>
  handleRequest(axios.get(`${api}lessons/${id}`), thunkAPI)
)

export const SPSessions = createAsyncThunk(
  'sessions',
  ({id, lesson_number}: {id: string; lesson_number: number}, thunkAPI) =>
    handleRequest(axios.get(`${api}sessions/${id}/${lesson_number}`), thunkAPI)
)

export const SPEvForms = createAsyncThunk('ev-graph', async (id: string, thunkAPI) => {
  return handleRequest(axios.get(`${api}ev-forms/${id}`), thunkAPI)
})

export const SPTranscript = createAsyncThunk('transcript', async (_, thunkAPI) => {
  return handleRequest(axios.get(`${api}transcript`), thunkAPI)
})

export const PSInvoices = createAsyncThunk('invoices', async (_, thunkAPI) => {
  return handleRequest(axios.get(`${api}invoices`), thunkAPI)
})

export const PSMeetings = createAsyncThunk('meetings', async (_, thunkAPI) => {
  return handleRequest(axios.get(`${api}meetings`), thunkAPI)
})

export const ParentList = createAsyncThunk('parents', async (params: {}, thunkAPI) => {
  return handleRequest(axios.get(`${api}list`, params), thunkAPI)
})

export const pEdit = createAsyncThunk('edit-parent', async (id: string, thunkAPI) => {
  return handleRequest(axios.get(`${api}edit-parent/${id}`), thunkAPI)
})

export const pUpdate = createAsyncThunk('update-parent', async (data: {}, thunkAPI) => {
  return handleRequest(axios.post(`${api}update-parent`, data), thunkAPI)
})

export const pEmail = createAsyncThunk('email-parent', async (data: {}, thunkAPI) => {
  return handleRequest(axios.post(`${api}email-parent`, data), thunkAPI)
})

export const pDestroy = createAsyncThunk('destroy', async (id: string, thunkAPI) => {
  return handleRequest(axios.get(`${api}destroy/${id}`), thunkAPI)
})

export const Students = createAsyncThunk('stds', async (_, thunkAPI) => {
  return handleRequest(axios.get(`${api}stds`), thunkAPI)
})

export const UpdatePAcc = createAsyncThunk('upa', async (id: any, thunkAPI) => {
  return handleRequest(axios.get(`${api}update-account/${id}`), thunkAPI)
})

type ParentState = {
  record: any
  records: any
  errors: any
}

const initialState: ParentState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}

export const parentSlice = createSlice({
  name: 'parent',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(storeParent.fulfilled, (state, action) => {
        state.record = action.payload.data
        state.errors = ''
      })
      .addCase(storeParent.rejected, (state, action: any) => {
        state.errors = action.payload?.errors || action.payload
      })
  },
})

export const {reset} = parentSlice.actions
export default parentSlice.reducer
